// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-245ce337] .icon-font-22 .font-16 {\n  font-size: 20px !important;\n}", ""]);
// Exports
module.exports = exports;
